import {
    FeatureTierLevel,
    FeatureTierLevelMap,
    FeatureType,
    StandardProAddOns,
} from '../types';
import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { Dialog } from '@material/mwc-dialog';
import { UpgradeDialogElement } from './upgrade-dialog';

@customElement('upgrade-div')
export class UpgradeDiv extends LitElement {
    static amplitude_callsite: string = 'Upgrade Text CTA';

    @query('#upgradeDialogComponent')
    upgradeDialogComponent!: Dialog;

    @query('#upgradeDialogInnerComponent')
    upgradeDialogInnerComponent!: UpgradeDialogElement;

    @property()
    text?: string;

    @property()
    tier?: FeatureTierLevel;

    @property()
    isLocked: boolean = false;

    @property()
    feature: FeatureType = FeatureType.PrintableMap;

    private openUpgradeDialog() {
        if (
            !FeatureTierLevelMap[this.feature].includes(FeatureTierLevel.ProBase)
        ) {
            // Anything not in Pro is a Premium feature — upsell the Premium bundle.
            this.upgradeDialogInnerComponent.addon = StandardProAddOns.HaveItAll;
        }

        this.upgradeDialogComponent?.show();
    }

    render() {
        return html`
            <div class="feature-container">
                <div class="${this.isLocked ? 'upgrade-area locked' : 'upgrade-area'}" @click="${this.isLocked ? this.openUpgradeDialog : null}">
                    ${this.isLocked
                        ? html`<div class="overlay" @click="${this.openUpgradeDialog}">
                                <mwc-icon class="upgrade-cta__icon">lock</mwc-icon>
                                ${this.text ?? `Available with ${this.tier ?? (FeatureTierLevelMap[this.feature].includes(FeatureTierLevel.ProBase) ? 'Pro' : 'Premium')}`}
                            </div>`
                        : ''
                    }
                    <slot></slot>
                </div>
                <mwc-dialog id="upgradeDialogComponent" class="dialog" hideActions>
                    <modal-dialog size="md" @close="${() => this.upgradeDialogComponent?.close()}">
                        <upgrade-dialog
                            id="upgradeDialogInnerComponent"
                            slot="body"
                            .featureType="${this.feature}"
                            @close="${() => this.upgradeDialogComponent?.close()}"
                        >
                        </upgrade-dialog>
                    </modal-dialog>
                </mwc-dialog>
            </div>
        `;
    }

    static get styles() {
        return css`
            .feature-container {
                position: relative;
            }

            .upgrade-area {
                cursor: pointer;
                position: relative;
            }

            .upgrade-area.locked {
                pointer-events: none; /* Disable pointer events for the locked area */
            }

            .upgrade-area.locked .overlay {
                pointer-events: all; /* Enable pointer events for the overlay */
            }

            .upgrade-area .overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(128, 128, 128, 0.5); /* Grey overlay */
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            }

            .upgrade-cta__icon {
                margin-right: 8px;
            }
        `;
    }
}



